import React from 'react';
import { Card } from 'react-bootstrap';

const GameCard = ({ card, onCardClick, isSelected, isMatched }) => {
  const handleClick = () => {
    if (!isMatched && !isSelected) {
      onCardClick(card);
    }
  };

  const getCardStyle = () => {
    let classes = 'game-card ';
    
    if (isMatched) {
      classes += 'matched ';
    } else if (isSelected) {
      classes += 'selected ';
    }
    
    if (card.type === 'chinese') {
      classes += 'chinese-card ';
    } else {
      classes += 'english-card ';
    }
    
    return classes;
  };

  return (
    <Card 
      className={getCardStyle()}
      onClick={handleClick}
      style={{
        width: '100px',
        height: '80px',
        margin: '5px',
        cursor: isMatched ? 'default' : 'pointer',
        transition: 'all 0.3s ease',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '14px',
        fontWeight: 'bold'
      }}
    >
      <Card.Body className="p-2 text-center">
        {card.text}
      </Card.Body>
    </Card>
  );
};

export default GameCard;